/**
 * lib/ninetailed/contentfulEntryUrl.ts
 *
 * Pure helper building the Contentful web-app entry-editor URL used by the
 * Ninetailed preview widget's "Go to editor" deep-links. Kept free of React/DOM
 * so it is trivially unit-testable under the repo's `%20`-folder constraint.
 *
 * Returns `null` when any required part (space id or entry id) is missing, so the
 * caller can no-op instead of opening a broken URL. Environment defaults to
 * `master` (Contentful's default) only when an explicit one is not provided.
 */

const CONTENTFUL_APP_HOST = 'https://app.contentful.com';

export function buildContentfulEntryUrl(
  spaceId: string | undefined,
  environment: string | undefined,
  entryId: string | undefined,
): string | null {
  if (!spaceId || !entryId) return null;
  const env = environment || 'master';
  return `${CONTENTFUL_APP_HOST}/spaces/${spaceId}/environments/${env}/entries/${entryId}`;
}
